import type { TableRowActionItem } from "@shared/components/UiTableRowActions/index.vue";
import { t } from "@shared/utils/i18n";

/** PO / DF 视图（与列表 Tab、列差异对应） */
export type AmazonVcLogisticsMappingKind = "PO" | "DF";

export const AMAZON_VC_LOGISTICS_MAPPING_KIND_OPTIONS = [
    { label: "PO", value: "PO" as AmazonVcLogisticsMappingKind },
    { label: "DF", value: "DF" as AmazonVcLogisticsMappingKind },
];

export const AMAZON_VC_LOGISTICS_MAPPING_PLATFORM_OPTIONS = [{ label: "Amazon", value: "amazon" }];

/** 名称仅模糊搜索，不开放多项精确 */
export const AMAZON_VC_LOGISTICS_MAPPING_COMBINED_SEARCH_OPTIONS = [{ label: t("名称"), value: "name", exact: false }];

/**
 * 列表项（复用 /manage/warehouseVcLogisticsChannel/list 的 items[]，
 * DF 场景额外可能带 trackingNumberPrefix）
 */
export interface AmazonVcLogisticsMappingItemApi {
    /** VC 物流渠道主键（与 logisticsChannel 同接口） */
    id: number | string;
    platformCode: string;
    platformLabel: string;
    vcType: string;
    vcTypeLabel: string;
    channelName: string;
    /** 跟踪号前缀（DF） */
    trackingNumberPrefix?: string;
    carrier: string;
    carrierLabel: string;
    logisticsType: string;
    logisticsTypeLabel: string;
    mappingCount: number;
    status: number;
    statusLabel: string;
    createdBy?: number;
    creatorName?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface AmazonVcLogisticsMappingRow {
    /** VC 物流渠道主键 */
    id: string;
    name: string;
    /** 跟踪号前缀（仅 DF 列展示） */
    trackingNumberPrefix: string;
    platform: string;
    platformCode: string;
    vcType: string;
    vcTypeCode: string;
    logisticsProvider: string;
    carrier: string;
    logisticsType: string;
    logisticsTypeCode: string;
    mappingCount: number;
    status: number;
    statusLabel: string;
}

export function mapAmazonVcLogisticsMappingItem(item: AmazonVcLogisticsMappingItemApi): AmazonVcLogisticsMappingRow {
    return {
        id: item.id != null && item.id !== "" ? String(item.id) : "",
        name: item.channelName,
        trackingNumberPrefix: item.trackingNumberPrefix ?? "",
        platform: item.platformLabel || item.platformCode,
        platformCode: item.platformCode,
        vcType: item.vcTypeLabel || item.vcType,
        vcTypeCode: item.vcType,
        logisticsProvider: item.carrierLabel || item.carrier,
        carrier: item.carrier,
        logisticsType: item.logisticsTypeLabel || item.logisticsType,
        logisticsTypeCode: item.logisticsType,
        mappingCount: item.mappingCount ?? 0,
        status: item.status,
        statusLabel: item.statusLabel,
    };
}

/** 行内操作：仅编辑（打开物流映射弹窗） */
export function getAmazonVcLogisticsMappingRowActions(): TableRowActionItem[] {
    return [{ label: t("编辑"), key: t("编辑") }];
}
